import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // ServiceFee Management
    SETTING_LOAD_SERVICE_FEE,
    // SETTING_LOAD_SERVICE_FEE_SUCCESS,
    SETTING_CREATE_SERVICE_FEE,
    SETTING_UPDATE_SERVICE_FEE,
    SETTING_DELETE_SERVICE_FEE,

    // SETTING_LOAD_POSITION,
    // // SETTING_LOAD_POSITION_SUCCESS,
    // SETTING_CREATE_POSITION,
    // SETTING_UPDATE_POSITION,
    // SETTING_DELETE_POSITION,

    // SETTING_LOAD_STAFF,
    // // SETTING_LOAD_STAFF_SUCCESS,
    // SETTING_CREATE_STAFF,
    // SETTING_UPDATE_STAFF,
    // SETTING_DELETE_STAFF,
    // END ServiceFee Management

} from "../../actions";

import {
    // ServiceFee Management
    settingGetServiceFee,
    settingAddServiceFee,
    settingUpdateServiceFee,
    settingDeleteServiceFee,

    // settingGetPosition,
    // settingAddPosition,
    // settingUpdatePosition,
    // settingDeletePosition,

    // settingGetStaff,
    // settingCreateStaff,
    // settingUpdateStaff,
    // settingDeleteStaff,
    // END ServiceFee Management

} from "../../../helpers/setting-api";

import {
    getServiceFee,
    getServiceFeeSuccess,
    // getPosition,
    // getPositionSuccess,
    // getStaff,
    // getStaffSuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// ServiceFee Management
function* settingManagementLoadServiceFee({ payload, token }) {
    try {
        const dataRes = yield settingGetServiceFee(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_service_fee,
                    value: item.id_service_fee,
                }
            ));
            yield put(getServiceFeeSuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddServiceFee({ payload, token }) {
    try {
        const dataRes = yield settingAddServiceFee(payload, token);
        if (dataRes.status === 'success') {
            yield put(getServiceFee({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateServiceFee({ payload, token }) {
    try {
        const dataRes = yield settingUpdateServiceFee(payload, token);
        if (dataRes.status === 'success') {
            yield put(getServiceFee({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getStaff({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteServiceFee({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteServiceFee(items, token);
        if (dataRes.status === 'success') yield put(getServiceFee({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementLoadPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingGetPosition(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: item.name_position,
//                     value: item.id_position,
//                 }
//             ));
//             yield put(getPositionSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementAddPosition({ payload, token }) {
//     try {
//         const dataRes = yield settingAddPosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementUpdatePosition({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdatePosition(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getPosition({ spa_id: payload.spa_id }, token));
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementDeletePosition({ payload, token }) {
//     const { items } = payload;
//     try {
//         const dataRes = yield settingDeletePosition(items, token);
//         if (dataRes.status === 'success') yield put(getPosition({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementLoadStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingGetStaff(payload, token);
//         if (dataRes.status === 'success') {
//             const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
//             const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
//             const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
//             const list = checkDataFilter.map(item => (
//                 {
//                     ...item,
//                     label: `${item.first_name} ${item.last_name}`,
//                     value: item.id_staff,
//                 }
//             ));
//             yield put(getStaffSuccess(checkDataFilter, list));
//         } else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementAddStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingCreateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//         } else
//             if
//                 (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }

//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else {
//                 yield PullNotificationManager(`${dataRes.msg}`);
//             }

//     } catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementUpdateStaff({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateStaff(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getStaff({ spa_id: payload.spa_id }, token));
//             // yield put(getPosition({ idHotel }, token));
//             // yield put(getUser());
//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// function* settingManagementDeleteStaff({ payload, token }) {
//     // const { items } = payload;
//     try {
//         const dataRes = yield settingDeleteStaff(payload, token);
//         if (dataRes.status === 'success') yield put(getStaff({ spa_id: payload.spa_id }, token));
//         else
//             if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             }
//             else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
//                 yield PullNotificationManager("RoleCategory is used.");
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         console.log('error', error)
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

// END ServiceFee Management

// ServiceFee Management
export function* watchLoadServiceFee() {
    yield takeEvery(
        SETTING_LOAD_SERVICE_FEE,
        settingManagementLoadServiceFee
    );
}
export function* watchAddServiceFee() {
    yield takeEvery(
        SETTING_CREATE_SERVICE_FEE,
        settingManagementAddServiceFee
    );
}
export function* watchUpdateServiceFee() {
    yield takeEvery(
        SETTING_UPDATE_SERVICE_FEE,
        settingManagementUpdateServiceFee
    );
}
export function* watchDeleteServiceFee() {
    yield takeEvery(
        SETTING_DELETE_SERVICE_FEE,
        settingManagementDeleteServiceFee
    );
}

// export function* watchLoadPosition() {
//     yield takeEvery(
//         SETTING_LOAD_POSITION,
//         settingManagementLoadPosition
//     );
// }
// export function* watchAddPosition() {
//     yield takeEvery(
//         SETTING_CREATE_POSITION,
//         settingManagementAddPosition
//     );
// }
// export function* watchUpdatePosition() {
//     yield takeEvery(
//         SETTING_UPDATE_POSITION,
//         settingManagementUpdatePosition
//     );
// }
// export function* watchDeletePosition() {
//     yield takeEvery(
//         SETTING_DELETE_POSITION,
//         settingManagementDeletePosition
//     );
// }

// export function* watchLoadStaff() {
//     yield takeEvery(
//         SETTING_LOAD_STAFF,
//         settingManagementLoadStaff
//     );
// }
// export function* watchAddStaff() {
//     yield takeEvery(
//         SETTING_CREATE_STAFF,
//         settingManagementAddStaff
//     );
// }
// export function* watchUpdateStaff() {
//     yield takeEvery(
//         SETTING_UPDATE_STAFF,
//         settingManagementUpdateStaff
//     );
// }
// export function* watchDeleteStaff() {
//     yield takeEvery(
//         SETTING_DELETE_STAFF,
//         settingManagementDeleteStaff
//     );
// }
// END ServiceFee Management

export default function* rootSaga() {
    yield all([
        //  ServiceFee Management
        fork(watchLoadServiceFee),
        fork(watchAddServiceFee),
        fork(watchUpdateServiceFee),
        fork(watchDeleteServiceFee),

        // fork(watchLoadPosition),
        // fork(watchAddPosition),
        // fork(watchUpdatePosition),
        // fork(watchDeletePosition),

        // fork(watchLoadStaff),
        // fork(watchAddStaff),
        // fork(watchUpdateStaff),
        // fork(watchDeleteStaff),
    ])
}